import { render, staticRenderFns } from "./final.vue?vue&type=template&id=263d3de5&scoped=true"
import script from "./final.vue?vue&type=script&lang=js"
export * from "./final.vue?vue&type=script&lang=js"
import style0 from "./final.vue?vue&type=style&index=0&id=263d3de5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263d3de5",
  null
  
)

export default component.exports